<script lang="ts">
  import { link } from 'svelte-navigator';
  import ButtonArrow from './ButtonArrow.svelte';

  export let error: string | null = null;
  export let loading: boolean | string = false;
  export let href: string | null = null;
  export let primary = false;
  export let secondary = false;
  export let transparent = false;

  let hover = false;

  function enter() {
    hover = true;
  }
  function leave() {
    hover = false;
  }
</script>

{#if href}
  <a
    {href}
    use:link
    class="button"
    class:error
    class:loading
    class:primary
    class:secondary
    class:transparent
    on:mouseover={enter}
    on:focus={enter}
    on:mouseout={leave}
    on:blur={leave}
  >
    <div class="container" class:container-open={hover}>
      {#if loading === true}
        Loading...
      {:else if loading}
        {loading}
      {:else if error}
        {error}
      {:else}
        <slot />
      {/if}
      {#if primary && !loading && !error}
        <span class="arrow-container animate shrink" class:open={hover}>
          <ButtonArrow open={hover} />
        </span>
      {/if}
    </div>
  </a>
{:else}
  <button
    class="button"
    class:error
    class:loading
    class:primary
    class:secondary
    class:transparent
    on:click
    on:mouseover={enter}
    on:focus={enter}
    on:mouseout={leave}
    on:blur={leave}
  >
    <div class="container" class:container-open={hover}>
      {#if loading === true}
        Loading...
      {:else if loading}
        {loading}
      {:else if error}
        {error}
      {:else}
        <slot />
      {/if}
      {#if primary && !loading && !error}
        <span class="arrow-container animate shrink">
          <ButtonArrow open={hover} />
        </span>
      {/if}
    </div>
  </button>
{/if}

<style>
  :root {
    --arrow-width: 50px;
  }

  .button {
    display: flex;
    justify-content: center;
    align-content: center;

    width: 100%;
    max-width: 320px;
    padding: 0.725rem 1rem;
    border: none;
    border-radius: 2rem;

    font-family: 'Cormorant Garamond';
    font-size: inherit;
    outline: none;
    background: var(--button);
    color: var(--button-text);
    text-transform: uppercase;
    letter-spacing: 2px;

    pointer-events: fill;
    cursor: pointer;
  }
  .primary {
    box-shadow: 0px 0px 0px 1px var(--highlight);
  }

  .secondary {
    font-family: 'Optima';
    padding: 0.8rem;
    text-transform: none;
    letter-spacing: 1px;
  }

  .transparent {
    background-color: transparent;
  }

  .error {
    background: var(--button-error);
    color: var(--button-error-text);
  }

  .button {
    text-decoration: none;
  }

  .button:focus {
    box-shadow: 0px 0px 0px var(--outline) var(--active);
    border: none;

    /* High-contrast */
    outline-color: transparent;
    outline-width: var(--outline);
    outline-style: dotted;
  }

  .container {
    display: flex;
    transition: transform var(--transition);
    align-items: center;
  }

  .primary .container {
    transform: translateX(var(--arrow-width));
  }

  .primary .container-open {
    transform: translateX(calc(var(--arrow-width) * 0.666));
  }

  .error .container,
  .error .container-open,
  .loading .container,
  .loading .container-open {
    transform: none;
  }

  .arrow-container {
    padding-left: 0.5rem;
    margin-right: var(--arrow-width);
    transition: all var(--transition);
  }

  @media screen and (min-width: 410px) {
    .button {
      max-width: 380px;
    }
  }

  @media screen and (min-width: 480px) {
    .button {
      max-width: 420px;
    }
  }
</style>
